import { MouseEvent } from "react"

import { LeadLog } from "../../../../../types"
import {
  DEFAULT_DATETIME_LONG_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"

type Props = {
  info: LeadLog
  onClick: (event: MouseEvent<HTMLDivElement>) => void
}

const OwnerCell = ({ info, onClick }: Props) => {
  const { owner_email, timestamp } = info

  return (
    <td
      className="hidden md:table-cell whitespace-nowrap py-4 px-3 cursor-pointer"
      onClick={onClick}
    >
      <div className="text-sm text-black">
        {formatDateTimeFromTimestamp(timestamp, DEFAULT_DATETIME_LONG_FORMAT)}
      </div>
      <div className="text-sm text-black">by&nbsp;{owner_email}</div>
    </td>
  )
}

export default OwnerCell
